/* =============================================
   LUARARTS — Custom Order Page JS
   Selects a service, collects design details, attaches them to the
   Shopify line item, and then redirects to secure checkout.
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  const form = document.getElementById('la-co-order-form');
  const orderForm = document.querySelector('[data-custom-order-form]');
  const message = orderForm?.querySelector('[data-custom-order-message]');
  const selectedPreview = document.querySelector('[data-selected-service-preview]');
  const selectedName = selectedPreview?.querySelector('[data-selected-service-name]');
  const selectedPrice = selectedPreview?.querySelector('[data-selected-service-price]');

  const showMessage = (text) => {
    if (!message) return;
    message.textContent = text;
    message.hidden = false;
  };

  document.querySelectorAll('[data-co-select]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!form) return;
      const pkg = btn.dataset.package;
      const radio = form.querySelector(`input[name="custom_order_package"][value="${CSS.escape(pkg)}"]`);
      if (radio) {
        radio.checked = true;
        if (btn.dataset.variantId) radio.dataset.variantId = btn.dataset.variantId;
      }
      if (selectedPreview) {
        if (selectedName) selectedName.textContent = pkg;
        if (selectedPrice) selectedPrice.textContent = btn.dataset.servicePrice || '';
        selectedPreview.hidden = false;
      }
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  orderForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    message.hidden = true;

    const selected = orderForm.querySelector('input[name="custom_order_package"]:checked');
    const variantId = Number(selected?.dataset.variantId || 0);
    if (!selected || !variantId) {
      showMessage('Please select an available package or add-on.');
      return;
    }

    const submitButton = orderForm.querySelector('button[type="submit"]');
    const formData = new FormData(orderForm);
    const originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Preparing checkout...';

    const properties = {
      'Selected service': selected.value,
      'Customer name': String(formData.get('customer_name') || ''),
      'Contact email': String(formData.get('customer_email') || ''),
      'X or Discord username': String(formData.get('contact_username') || ''),
      'Design details': String(formData.get('design_details') || ''),
      'Reference links': String(formData.get('reference_links') || '')
    };

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
      });

      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      showMessage('The checkout could not be prepared. Please try again.');
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  });
});
